import { Stack } from "@mui/material";
import type { SkillsListHeaderProps } from "../types";
import { SkillsFilterMenu } from "./SkillsFilterMenu";
import { SkillsListSearch } from "./SkillsListSearch";
import { SkillsNewMenuButton } from "./SkillsNewMenuButton";

export const SkillsListHeader = ({
  filter,
  search,
  onFilterChange,
  onSearchChange,
  onCreateSkill,
  onUploadSkill,
}: SkillsListHeaderProps) => (
  <Stack
    gap={1.25}
    sx={{
      paddingTop: 0,
      paddingRight: 1.3125,
      paddingBottom: 0,
      paddingLeft: 1.3125,
      marginBottom: 0,
      borderBottom: "1px solid",
      borderColor: "divider",
    }}
    data-testid="skills-list-header"
  >
    <Stack
      direction="row"
      alignItems="center"
      gap={0.75}
      justifyContent="flex-end"
      sx={{
        minHeight: 36.5,
        "& .MuiIconButton-root": {
          color: "text.secondary",
        },
      }}
      data-testid="skills-list-toolbar"
    >
      <SkillsListSearch search={search} onSearchChange={onSearchChange} />
      <SkillsFilterMenu filter={filter} onFilterChange={onFilterChange} />
      <SkillsNewMenuButton
        onCreateSkill={onCreateSkill}
        onUploadSkill={onUploadSkill}
      />
    </Stack>
  </Stack>
);
